module.exports = __webpack_public_path__ + "static/media/cog-box.041c510e.svg";